/*
Copyright 2025 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const NamingOrderIcon = ({
  width = 24,
  height = 24,
  hidden = false,
  title = 'Naming Order',
} = {}): string | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    width="${width}"
    height="${height}"
    viewBox="0 0 20 20"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="M10.54639,11.00391L6.68945,2.00391c-.23633-.55078-1.14258-.55078-1.37891,0L1.45361,11.00391c-.16309.38086.01318.82227.39404.98535.37891.16113.82129-.0127.98486-.39355l1.1123-2.5957h4.11035l1.1123,2.5957c.12207.28418.39893.4541.68994.4541.09863,0,.19873-.01953.29492-.06055.38086-.16309.55713-.60449.39404-.98535ZM4.58765,7.5l1.41235-3.2959,1.41235,3.2959h-2.82471Z"
      fill="currentColor"
    />
    <path
      d="M17.25,18h-5.5c-.2749,0-.52734-.15039-.65869-.3916s-.12012-.53516.02881-.76562l4.75146-7.34277h-4.12158c-.41406,0-.75-.33594-.75-.75s.33594-.75.75-.75h5.5c.2749,0,.52734.15039.65869.3916s.12012.53516-.02881.76562l-4.75146,7.34277h4.12158c.41406,0,.75.33594.75.75s-.33594.75-.75.75Z"
      fill="currentColor"
    />
  </svg>`;
};
